import { denormalisedResponseEntities, onGetCloudnaryData, makeCreateUpdateAlgoliaUserData, getUserType } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess } from '../../ducks/user.duck';
import { UploadImage } from '../../util/cloudinary';
import { convertFileToMd5, mountFileToSend } from '../../util/circleHelper';
import {
  createDirectUpload,
  fetchCommunityMember,
  getCurrentUserCircleAuthParams,
  onGetCircleAuthToken,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import { updateCurrentCircleUserApi, onCheckUserAlreadyExistApi, algoliaCRUDApis, updateUserApi, fetchUserApi, upsertUserDetailsApi } from '../../util/api';
import { CREATE_ALGOLIA_TYPE, CURRENT_USER_BUSINESS_TYPE, CURRENT_USER_INDIVIDUAL_TYPE, USER_TYPE_YOUTH } from '../../util/types';
import { getUserData } from '../ProfilePage/ProfilePage.duck';


// ================ Action types ================ //



export const CLEAR_UPDATED_FORM = 'app/ProfileSettingsPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_IMAGE_ERROR';

export const UPLOAD_GALLERY_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_GALLERY_IMAGE_REQUEST';
export const UPLOAD_GALLERY_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_GALLERY_IMAGE_SUCCESS';
export const UPLOAD_GALLERY_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_GALLERY_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_ERROR';

export const UPDATE_PROFILE_CIRCLE_IMAGE = 'app/ProfileSettingPage/UPDATE_PROFILE_CIRCLE_IMAGE';

// Check user by email
export const CHECK_USER_BY_EMAIL_REQUEST = 'app/ProfileSettingsPage/CHECK_USER_BY_EMAIL_REQUEST';
export const CHECK_USER_BY_EMAIL_SUCCESS = 'app/ProfileSettingsPage/CHECK_USER_BY_EMAIL_SUCCESS';
export const CHECK_USER_BY_EMAIL_ERROR = 'app/ProfileSettingsPage/CHECK_USER_BY_EMAIL_ERROR';

// Algolia user update action types
export const UPDATE_USER_ALGOLIA_REQUEST = 'app/ProfileSettingsPage/UPDATE_USER_ALGOLIA_REQUEST';
export const UPDATE_USER_ALGOLIA_SUCCESS = 'app/ProfileSettingsPage/UPDATE_USER_ALGOLIA_SUCCESS';
export const UPDATE_USER_ALGOLIA_ERROR = 'app/ProfileSettingsPage/UPDATE_USER_ALGOLIA_ERROR';

// SMS Verification action types
export const SEND_OTP_REQUEST = 'app/ProfileSettingsPage/SEND_OTP_REQUEST';
export const SEND_OTP_SUCCESS = 'app/ProfileSettingsPage/SEND_OTP_SUCCESS';
export const SEND_OTP_ERROR = 'app/ProfileSettingsPage/SEND_OTP_ERROR';

export const VERIFY_OTP_REQUEST = 'app/ProfileSettingsPage/VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'app/ProfileSettingsPage/VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'app/ProfileSettingsPage/VERIFY_OTP_ERROR';

export const CLEAR_SMS_VERIFICATION_STATE = 'app/ProfileSettingsPage/CLEAR_SMS_VERIFICATION_STATE';

// Phone number availability check action types
export const CHECK_PHONE_AVAILABILITY_REQUEST = 'app/ProfileSettingsPage/CHECK_PHONE_AVAILABILITY_REQUEST';
export const CHECK_PHONE_AVAILABILITY_SUCCESS = 'app/ProfileSettingsPage/CHECK_PHONE_AVAILABILITY_SUCCESS';
export const CHECK_PHONE_AVAILABILITY_ERROR = 'app/ProfileSettingsPage/CHECK_PHONE_AVAILABILITY_ERROR';
export const CLEAR_PHONE_AVAILABILITY_STATE = 'app/ProfileSettingsPage/CLEAR_PHONE_AVAILABILITY_STATE';

// ================ Reducer ================ //

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,
  circleData: null,
  // check user by email
  checkUserByEmailInProgress: false,
  checkUserByEmailError: null,
  // Will store full response object from API: { exists, data }
  isUserEmailExists: null,
  galleryImages: {},
  galleryUploadInProgress: false,
  galleryUploadError: null,
  // SMS Verification
  sendOTPInProgress: false,
  sendOTPError: null,
  sendOTPSuccess: false,
  verifyOTPInProgress: false,
  verifyOTPError: null,
  verifyOTPSuccess: false,
  // Phone number availability check
  checkPhoneAvailabilityInProgress: false,
  checkPhoneAvailabilityError: null,
  phoneAvailability: null, // { available: boolean, message: string }
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PROFILE_CIRCLE_IMAGE:
      return {
        ...state,
        circleData: payload
      };
    case UPLOAD_GALLERY_IMAGE_REQUEST:
      return {
        ...state,
        galleryUploadInProgress: payload?.params?.index,
        galleryUploadError: null
      };
    case UPLOAD_GALLERY_IMAGE_SUCCESS:
      return {
        ...state,
        galleryUploadInProgress: false,
        galleryImages: {
          ...state.galleryImages,
          [payload.id]: payload.image
        }
      };
    case UPLOAD_GALLERY_IMAGE_ERROR:
      return {
        ...state,
        galleryUploadInProgress: false,
        galleryUploadError: payload
      };
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage, cloudProfileImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage, cloudProfileImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR: {
      // eslint-disable-next-line no-console
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };
    }

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    // Check user by email
    case CHECK_USER_BY_EMAIL_REQUEST:
      return {
        ...state,
        checkUserByEmailInProgress: true,
        checkUserByEmailError: null,
      };
    case CHECK_USER_BY_EMAIL_SUCCESS: {
      return {
        ...state,
        checkUserByEmailInProgress: false,
        // Store full payload so consumer can access exists flag and full data
        isUserEmailExists: payload || null,
      };
    }
    case CHECK_USER_BY_EMAIL_ERROR:
      return {
        ...state,
        checkUserByEmailInProgress: false,
        checkUserByEmailError: payload,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    // SMS Verification cases
    case SEND_OTP_REQUEST:
      return {
        ...state,
        sendOTPInProgress: true,
        sendOTPError: null,
        sendOTPSuccess: false,
      };
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        sendOTPInProgress: false,
        sendOTPSuccess: true,
      };
    case SEND_OTP_ERROR:
      return {
        ...state,
        sendOTPInProgress: false,
        sendOTPError: payload,
      };

    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        verifyOTPInProgress: true,
        verifyOTPError: null,
        verifyOTPSuccess: false,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        verifyOTPInProgress: false,
        verifyOTPSuccess: true,
      };
    case VERIFY_OTP_ERROR:
      return {
        ...state,
        verifyOTPInProgress: false,
        verifyOTPError: payload,
      };

    case CLEAR_SMS_VERIFICATION_STATE:
      return {
        ...state,
        sendOTPInProgress: false,
        sendOTPError: null,
        sendOTPSuccess: false,
        verifyOTPInProgress: false,
        verifyOTPError: null,
        verifyOTPSuccess: false,
      };

    // Phone availability check cases
    case CHECK_PHONE_AVAILABILITY_REQUEST:
      return {
        ...state,
        checkPhoneAvailabilityInProgress: true,
        checkPhoneAvailabilityError: null,
      };
    case CHECK_PHONE_AVAILABILITY_SUCCESS:
      return {
        ...state,
        checkPhoneAvailabilityInProgress: false,
        phoneAvailability: payload,
      };
    case CHECK_PHONE_AVAILABILITY_ERROR:
      return {
        ...state,
        checkPhoneAvailabilityInProgress: false,
        checkPhoneAvailabilityError: payload,
        phoneAvailability: null,
      };
    case CLEAR_PHONE_AVAILABILITY_STATE:
      return {
        ...state,
        checkPhoneAvailabilityInProgress: false,
        checkPhoneAvailabilityError: null,
        phoneAvailability: null,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

// Save signed_id in the duck when save button is click update the circle
export const circleSuccess = data => ({ type: UPDATE_PROFILE_CIRCLE_IMAGE, payload: data.data });

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

// Action creators for Algolia user update
export const updateUserAlgoliaRequest = () => ({
  type: UPDATE_USER_ALGOLIA_REQUEST,
});

export const updateUserAlgoliaSuccess = (response) => ({
  type: UPDATE_USER_ALGOLIA_SUCCESS,
  payload: response,
});

export const updateUserAlgoliaError = (error) => ({
  type: UPDATE_USER_ALGOLIA_ERROR,
  payload: error,
  error: true,
});

// Check user by email action creators
export const checkUserByEmailRequest = () => ({ type: CHECK_USER_BY_EMAIL_REQUEST });
export const checkUserByEmailSuccess = result => ({ type: CHECK_USER_BY_EMAIL_SUCCESS, payload: result });
export const checkUserByEmailError = error => ({ type: CHECK_USER_BY_EMAIL_ERROR, payload: error, error: true });

// SMS Verification action creators
export const sendOTPRequest = () => ({ type: SEND_OTP_REQUEST });
export const sendOTPSuccess = () => ({ type: SEND_OTP_SUCCESS });
export const sendOTPError = error => ({ type: SEND_OTP_ERROR, payload: error, error: true });

export const verifyOTPRequest = () => ({ type: VERIFY_OTP_REQUEST });
export const verifyOTPSuccess = () => ({ type: VERIFY_OTP_SUCCESS });
export const verifyOTPError = error => ({ type: VERIFY_OTP_ERROR, payload: error, error: true });

export const clearSmsVerificationState = () => ({ type: CLEAR_SMS_VERIFICATION_STATE });

// Phone availability check action creators
export const checkPhoneAvailabilityRequest = () => ({ type: CHECK_PHONE_AVAILABILITY_REQUEST });
export const checkPhoneAvailabilitySuccess = result => ({
  type: CHECK_PHONE_AVAILABILITY_SUCCESS,
  payload: result
});
export const checkPhoneAvailabilityError = error => ({
  type: CHECK_PHONE_AVAILABILITY_ERROR,
  payload: error,
  error: true
});
export const clearPhoneAvailabilityState = () => ({ type: CLEAR_PHONE_AVAILABILITY_STATE });

// ================ Thunk ================ //


export function updateCurrentCircleUserData(actionPayload) {
  return async (dispatch, getState, sdk) => {
    try {
      const { data } = actionPayload
      const currentUser = getState()?.user?.currentUser;
      const { access_token } = await onGetCircleAuthToken(
        getCurrentUserCircleAuthParams(currentUser)
      );
      const profileResponse = await updateCurrentCircleUserApi({ accessToken: access_token, data: data });

      return profileResponse;
    } catch (e) {
      console.log(e, '^^^  ^^^ => e');
    }
  }
}


const updateUserCircleProfileImage = async (file, dispatch, getState) => {
  try {
    const md5 = await convertFileToMd5(file);
    const fileMetadata = mountFileToSend(file, md5);
    const response = await dispatch(createDirectUpload(fileMetadata, file));
    const { signed_id } = response || {};
    const data = { community_member: { avatar: signed_id } };

    return data;

  } catch (error) {
    console.log('error', error);
  }
};

// Images return imageId which we need to map with previously generated temporary id
export function uploadImage(actionPayload) {
  return (dispatch, getState, sdk) => {
    const { id, file } = actionPayload;

    dispatch(uploadImageRequest(actionPayload));

    const bodyParams = {
      image: file,
    };
    const queryParams = {
      expand: true,
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(async resp => {
        const uploadedImage = resp.data.data;
        const data = await updateUserCircleProfileImage(file, dispatch, getState);
        // <<<<<<<< upload image in cloudnary >>>>>>>>>>>>>>>
        const cloudnaryResponse = await UploadImage({ id: uploadedImage.id.uuid, file, folder: 'profile-images' });
        dispatch(
          uploadImageSuccess({
            data: { id, uploadedImage, cloudProfileImage: onGetCloudnaryData(cloudnaryResponse) },
          })
        );
        dispatch(circleSuccess({ data }))
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

export const uploadBusinessGalleryImageRequest = params => ({
  type: UPLOAD_GALLERY_IMAGE_REQUEST,
  payload: { params }
});

export const uploadBusinessGalleryImageSuccess = image => ({
  type: UPLOAD_GALLERY_IMAGE_SUCCESS,
  payload: image
});

export const uploadBusinessGalleryImageError = error => ({
  type: UPLOAD_GALLERY_IMAGE_ERROR,
  error: true,
  payload: error
});

// Images return imageId which we need to map with previously generated temporary id
export const uploadBusinessGalleryImage = (actionPayload) => (dispatch, getState, sdk) => {

  const { file, id, index } = actionPayload;

  if (!file || !id) {
    return Promise.reject(new Error('File and ID are required'));
  }

  dispatch(uploadBusinessGalleryImageRequest({ id, file, index }));

  return UploadImage({ id, file, folder: 'storefront-gallery' })
    .then(cloudinaryResponse => {
      const cloudImage = onGetCloudnaryData(cloudinaryResponse);
      dispatch(uploadBusinessGalleryImageSuccess({ id, image: cloudImage }));
      return cloudImage;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(uploadBusinessGalleryImageError(error));
      throw error;
    });
};


const updateCircleProfile = async (actionPayload, dispatch, getState) => {
  const currentUser = getState()?.user?.currentUser;
  const userId = currentUser?.id?.uuid;
  const { access_token, community_member_id } = await onGetCircleAuthToken(
    getCurrentUserCircleAuthParams(currentUser)
  );
  await dispatch(fetchCommunityMember(access_token, community_member_id));
  const { firstName, lastName, bio, displayName } = actionPayload;

  const { currentCommunityMember } = getState()?.CircleCommunityPage;
  const { profile_fields } = currentCommunityMember || {};
  const bioField = profile_fields?.visible?.find(item => item.key === 'bio');
  const bioParams = {
    textarea: bio || '',
    profile_field_id: bioField?.id,
    id: bioField?.community_member_profile_field?.id || null,
  };

  const data = {
    community_member: {
      ...(firstName ? { name: firstName + ' ' + (lastName ? lastName : '')  } : {}),
      headline: userId,
      community_member_profile_fields_attributes: [...(bio ? [bioParams] : [])],
    },
  };
  const profileResponse = await updateCurrentCircleUserApi({ accessToken: access_token, data });
};

export const checkIsUserAvilableWithEmail = (email, currentUserType) => {
  return async dispatch => {
    dispatch(checkUserByEmailRequest());

    try {
      const response = await onCheckUserAlreadyExistApi({ email });
      const user = response?.user || null;
      const expectedUserType =
        currentUserType === CURRENT_USER_BUSINESS_TYPE
          ? CURRENT_USER_INDIVIDUAL_TYPE
          : CURRENT_USER_BUSINESS_TYPE;
      const foundUserType = user?.attributes?.profile?.publicData?.currentUserType;
      const result = {
        exists: !!user && foundUserType === expectedUserType,
        user,
      };

      dispatch(checkUserByEmailSuccess(result));
      return result;
    } catch (e) {
      const err = storableError(e);
      dispatch(checkUserByEmailError(err));
      throw err;
    }
  };
};

export const removedLinkedProfile = actionPayload => {
  return async (dispatch, getState, sdk) => {
    try {
      const currentUser = getState()?.user?.currentUser;
      const publicData = currentUser?.attributes?.profile?.publicData || {};
      const connectedAccountId = publicData?.connectedAccount?.linkedAccountUserId;

      if (connectedAccountId) {
        const updatePayloadForFoundUser = {
          publicData: {
            AccountVerificationStatus : null
          },
        };

        await updateUserApi({ userId: connectedAccountId, payload: updatePayloadForFoundUser });

        const updatePayloadForCurrentUser = {
          publicData: {
            AccountVerificationStatus: null,
            connectedAccount: null,
          },
        };
        // Update the current user's profile with the connected account details
        await dispatch(updateProfile(updatePayloadForCurrentUser));
      }
    } catch (e) {
      const err = storableError(e);
      console.error('Error removing linked profile:', err);
    }
  };
};

export const UpdateAccptDeclineConnectedAccountRequest = (type) => {
  return async (dispatch, getState, sdk) => {
    try {
      const currentUser = getState()?.user?.currentUser;
      const connectedAccountRequest = currentUser?.attributes?.profile?.publicData?.connectedAccountRequest || {};
      if (type === 'accept') {
        const updatePayloadForFoundUser = {
          publicData: {
            AccountVerificationStatus: "verified",
          },
        };
        await updateUserApi({ userId: connectedAccountRequest?.linkedAccountUserId, payload: updatePayloadForFoundUser }).then((res)=>{
          const updatePayloadForCurrentUser = {
            publicData: {
              connectedAccountRequest: {
                ...connectedAccountRequest,
                AccountVerificationStatus: "verified",
              },
            },
          };
          // Update the current user's profile with the connected account details
          dispatch(updateProfile(updatePayloadForCurrentUser));
        })
      }else{
        const updatePayloadForFoundUser = {
          publicData: {
            AccountVerificationStatus: "declined",
          },
        };
        await updateUserApi({ userId: connectedAccountRequest?.linkedAccountUserId, payload: updatePayloadForFoundUser }).then((res)=>{
          const updatePayloadForCurrentUser = {
            publicData: {
              connectedAccountRequest: {
                ...connectedAccountRequest,
                AccountVerificationStatus: "declined",
              },
            },
          };
          // Update the current user's profile with the connected account details
          dispatch(updateProfile(updatePayloadForCurrentUser));
        })
      }
    } catch (e) {
      const err = storableError(e);
      console.error('Error removing linked profile:', err);
    }
  };
}



export const updateProfile            = actionPayload => {
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());
    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams)
      .then(async response => {
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];

        // Push user update for connected account request
        // pushUserUpdateForConnectedAccount(currentUser, sdk).then(response => {
        //   if (response) {
        //     console.log(response, ' response');
        //   }
        // });
        // Update current user in state.user.currentUser through user.duck.js


        dispatch(currentUserShowSuccess(currentUser));

        const syncTasks = [
          updateCircleProfile(actionPayload, dispatch, getState),
          dispatch(updateUserInAlgolia(currentUser?.id?.uuid, {})),
        ];

        const userId = currentUser?.id?.uuid;
        const phoneNumber = actionPayload?.protectedData?.phoneNumber;
        const smsNotificationsEnabled = actionPayload?.publicData?.PhoneNumberSmsNotification;

        if (userId && typeof actionPayload?.protectedData !== 'undefined') {
          // Compare submitted phone number against the verified number in protectedData.
          // smsNotificationsEnabled should only be true if the submitted number matches
          // the verified number stored in protectedData.
          const verifiedPhoneNumber = currentUser?.attributes?.profile?.protectedData?.phoneNumber;
          const isPhoneVerified = currentUser?.attributes?.profile?.protectedData?.phoneNumberVerified;
          const sanitize = num => (num ? num.replace(/\D/g, '') : '');
          const isSubmittedNumberVerified =
            isPhoneVerified &&
            verifiedPhoneNumber &&
            sanitize(phoneNumber) === sanitize(verifiedPhoneNumber);

          // Only allow smsNotificationsEnabled=true if the phone number is verified
          const resolvedSmsEnabled = smsNotificationsEnabled && isSubmittedNumberVerified
            ? true
            : false;
          syncTasks.push(upsertUserDetailsApi({ userId, phoneNumber, smsNotificationsEnabled: resolvedSmsEnabled }));
        } else if (userId && smsNotificationsEnabled !== undefined) {
          syncTasks.push(upsertUserDetailsApi({ userId, smsNotificationsEnabled }));
        }

        const syncResults = await Promise.allSettled(syncTasks);
        syncResults
          .filter(result => result.status === 'rejected')
          .forEach(result => console.error('Profile external sync failed:', result.reason));

        dispatch(updateProfileSuccess(response));
        return currentUser;
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

// Separate thunk for updating user in Algolia (non-blocking)
export const updateUserInAlgolia = (userId, actionPayload = {}) => {
  return async (dispatch, getState, sdk) => {
    try {
      // Fetch user data
      const data = await fetchUserApi({ userId: userId });
      const currentUser = data?.userData || {};

      if (!currentUser?.id?.uuid) {
        console.log("user is missing!!");
        return;
      }
      // Extract stripe linked status from user data
      const protectedData = currentUser?.attributes?.profile?.protectedData || {};
      const privateData = currentUser?.attributes?.profile?.privateData || {};
      const { isAuthorStripeAccountLinked, stripeAccountId } = protectedData;
      const stripeLinked = !!isAuthorStripeAccountLinked && !!stripeAccountId;
      const emailVerified = currentUser?.attributes?.emailVerified || false;
      const isElephantDecisionApproved =
        privateData?.elephantDecision == 'approved' ||
        privateData?.platformPermission == 'granted' ||
        actionPayload?.platformPermission == 'granted';
      const userRole = currentUser?.attributes?.profile?.publicData?.userRole;
      const userType = currentUser?.attributes?.profile?.publicData?.currentUserType;
      const userRoleIsYouth = userRole == USER_TYPE_YOUTH;
      const userEmailVerifiedandApprovedbyElephant = isElephantDecisionApproved && emailVerified;

      dispatch(updateUserAlgoliaRequest());

      const indexName = process.env.REACT_APP_ALGOLIA_USERS || 'THQ_USERS';
      let state = 'invalid';

      // Youth users always get "invalid" state
      if (userRoleIsYouth) {
        state = 'invalid';
      }
      // Individual users get "valid" state
      else if (userType === CURRENT_USER_INDIVIDUAL_TYPE) {
        state = userEmailVerifiedandApprovedbyElephant ? 'valid' : "invalid";
      }
      // Business users need validation
      else if (userType === CURRENT_USER_BUSINESS_TYPE) {
        const profile = currentUser?.attributes?.profile || {};
        const publicData = profile.publicData || {};

        // Check required fields for business users
        const hasBio = !!profile.bio;
        const hasStoreName = !!publicData.storeName;
        const hasZip = !!publicData?.zipCode;
        const hasFirstName = !!profile.firstName;
        const hasLastName = !!profile.lastName;
        const hasPrimaryBusinessCategory = !!publicData.primaryBusinessCategory;
        // const hasOtherBusinessCategories =
        //   Array.isArray(publicData.otherBusinessCategories) &&
        //   publicData.otherBusinessCategories.length > 0;
        const hasprofileImage = !!publicData.cloudProfileImage?.secure_url;
        // Business user is valid only if all required fields are present
        const isBusinessProfileComplete =
          hasBio &&
          hasStoreName &&
          hasZip &&
          hasFirstName &&
          hasLastName &&
          hasprofileImage &&
          hasPrimaryBusinessCategory;
        // hasOtherBusinessCategories;
        state = isBusinessProfileComplete && userEmailVerifiedandApprovedbyElephant ? 'valid' : 'invalid';
      }
      // Merge state with any additional fields from actionPayload
      const updateParams = {
        state,
        stripeConnected: stripeLinked,
        ...actionPayload
      };
      const userData = makeCreateUpdateAlgoliaUserData(
        indexName,
        currentUser,
        {},
        updateParams
      );
      // Update Algolia
      const algoliaResponse = await algoliaCRUDApis(CREATE_ALGOLIA_TYPE, userData);
      dispatch(updateUserAlgoliaSuccess(algoliaResponse));

      console.log('✅ Successfully updated user in Algolia');
      return algoliaResponse;

    } catch (algoliaError) {
      console.error('❌ Error updating user in Algolia:', algoliaError);
      dispatch(updateUserAlgoliaError(algoliaError));
      throw algoliaError;
    }
  };
};

// ================ SMS Verification Thunks ================ //

/**
 * Send OTP to phone number
 */
export const sendOTP = phoneNumber => {
  return async (dispatch, getState, sdk) => {
    dispatch(sendOTPRequest());

    try {
      const { sendOTPApi } = require('../../util/api');
      const response = await sendOTPApi({ phoneNumber });

      if (response.success) {
        dispatch(sendOTPSuccess());
        return { success: true, message: 'OTP sent successfully' };
      } else {
        const error = new Error(response.message || 'Failed to send OTP');
        // Check if it's a rate limit error
        if (response.rateLimitExceeded) {
          error.rateLimitExceeded = true;
        }
        dispatch(sendOTPError(storableError(error)));
        return {
          success: false,
          message: error.message,
          rateLimitExceeded: response.rateLimitExceeded
        };
      }
    } catch (error) {
      console.error('Error sending OTP:', error);

      // Check if the error response indicates rate limiting
      const isRateLimitError = error.status === 429 ||
                               error.message?.includes('maximum number of OTP requests') ||
                               error.message?.includes('Rate limit exceeded');

      if (isRateLimitError) {
        const rateLimitError = new Error('You have reached the maximum number of OTP requests. Please try again later.');
        rateLimitError.rateLimitExceeded = true;
        dispatch(sendOTPError(storableError(rateLimitError)));
        return {
          success: false,
          message: rateLimitError.message,
          rateLimitExceeded: true
        };
      }

      dispatch(sendOTPError(storableError(error)));
      return { success: false, message: 'Failed to send OTP. Please try again.' };
    }
  };
};

/**
 * Verify OTP and update user profile
 */
export const verifyOTP = (phoneNumber, code) => {
  return async (dispatch, getState, sdk) => {
    dispatch(verifyOTPRequest());

    try {
      const { verifyOTPApi } = require('../../util/api');
      const response = await verifyOTPApi({ phoneNumber, code });

      if (response.verified) {
        dispatch(verifyOTPSuccess());

        // Get current user
        const state = getState();
        const currentUser = state.user.currentUser;
        const userId = currentUser?.id?.uuid;

        // Update MongoDB
        if (userId) {
          await upsertUserDetailsApi({ userId, phoneNumber });
        }

        return { success: true, verified: true, message: 'Phone number verified successfully' };
      } else {
        const error = new Error(response.message || 'Invalid verification code');
        dispatch(verifyOTPError(storableError(error)));
        return { success: false, verified: false, message: error.message };
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      dispatch(verifyOTPError(storableError(error)));
      return { success: false, verified: false, message: 'Failed to verify code. Please try again.' };
    }
  };
};

/**
 * Check if a phone number is available (not taken by another user)
 */
export const checkPhoneAvailability = (phoneNumber) => {
  return async (dispatch, getState, sdk) => {
    // Clear previous state
    dispatch(clearPhoneAvailabilityState());

    // If phone number is empty, it's available
    if (!phoneNumber || !phoneNumber.trim()) {
      dispatch(checkPhoneAvailabilitySuccess({
        available: true,
        message: 'Phone number is empty'
      }));
      return { available: true };
    }

    dispatch(checkPhoneAvailabilityRequest());

    try {
      const { checkPhoneAvailabilityApi } = require('../../util/api');
      const currentUser = getState().user.currentUser;
      const currentUserId = currentUser?.id?.uuid;

      const response = await checkPhoneAvailabilityApi({
        phoneNumber,
        currentUserId
      });

      dispatch(checkPhoneAvailabilitySuccess(response));
      return response;
    } catch (error) {
      console.error('Error checking phone availability:', error);
      const err = storableError(error);
      dispatch(checkPhoneAvailabilityError(err));
      return {
        available: false,
        error: true,
        message: 'Failed to check phone number availability'
      };
    }
  };
};
